<div class="d-flex flex-column justify-content-center align-items-center vh-100 text-center">

<h5>Welcome to the world of DECKorate !</h5>
<p>You are successfully logged in. Will be redirected to the page shortly.</p>
</div>